import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Login from './pages/Login';
import NotFound from './pages/Page404';
import ComingSoon from './pages/ComingSoon';
import SoundBoxDashboard from './pages/SoundBoxDashboard';
import SoundBoxDeviceDetails from './pages/SoundBoxDeviceDetails';
import OrganizationUsers from './pages/OrganizationUsers';
import MerchantListAudioCube from './pages/MerchnatsAudioCube';
import ForgetPassword from './pages/ForgetPassword';

import { useAuth } from './components/customContextProviders/AuthContext';
import ResetPassword from './pages/ResetPassword';
import MerchantOnboarding from './pages/MerchantOnboarding';
import UserProfile from './pages/UserProfile';
import TicketManagement from './ticketManagement/pages/TicketManagement';
import ValidateOTP from './pages/ValidateOTP';
import ChanakyaLandingPage from './pages/ChankayaLandingPage';
import { APP_CONSTANTS } from './URLConstants';
import RegionManagement from './hierarchyManagement/pages/RegionManagement';
import BranchManagement from './hierarchyManagement/pages/BranchManagement';


export const useAuthCheck = () => {
  const { sessionUserData } = useAuth();

  return {
    isAuthenticated: !!sessionUserData,
    sessionUserData
  };
};

export default function Router() {
  const { isAuthenticated } = useAuthCheck();
  const { userLoginOrg } = useAuth();

  return useRoutes([
    {
      path: '/dashboard',
      element: isAuthenticated ? <DashboardLayout /> : <Navigate to="/login" replace />,
      children: [
        { element: <Navigate to="/dashboard/soundboxT" replace /> },
        {
          path: 'soundboxT',
          element:
            userLoginOrg === APP_CONSTANTS?.SBI_CLIENT_IDENTIFIER ? (
              <ChanakyaLandingPage />
            ) : (
              <SoundBoxDashboard />
            )
        },
        {
          path: 'soundboxdevicedetails/:merchantId/:organizationId',
          element: <SoundBoxDeviceDetails />
        },
        { path: 'organizationusers', element: <OrganizationUsers /> },
        { path: 'merchants', element: <MerchantListAudioCube /> },
        { path: 'merchantOnboarding', element: <MerchantOnboarding /> },
        { path: 'userProfile', element: <UserProfile /> },
        { path: 'ticketManagement', element: <TicketManagement /> },
        { path: 'regions', element: <RegionManagement /> },
        { path: 'branches', element: <BranchManagement /> }
      ]
    },

    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        {
          path: 'login',
          element: isAuthenticated ? <Navigate to="/dashboard/soundboxT" replace /> : <Login />
        },
        {
          path: 'resetpassword/:token',
          element: isAuthenticated ? (
            <Navigate to="/dashboard/soundboxT" replace />
          ) : (
            <ResetPassword />
          )
        },
        {
          path: 'forgetpassword',
          element: isAuthenticated ? (
            <Navigate to="/dashboard/soundboxT" replace />
          ) : (
            <ForgetPassword />
          )
        },
        {
          path: 'validateotp',
          element: isAuthenticated ? (
            <Navigate to="/dashboard/soundboxT" replace />
          ) : (
            <ValidateOTP />
          )
        },
        { path: '404', element: <NotFound /> },
        { path: 'comingsoon', element: <ComingSoon /> },
        {
          path: '/',
          element: isAuthenticated ? (
            <Navigate to="/dashboard/soundboxT" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
